<template>
  <card>
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="true"
      :fields="fields" :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "tariff",
      fields: [
        {
          key: "title",
          label: "Название",
          isMultiLang: true,
          type: 'field',
        },
        {
          key: "description",
          label: "Краткое описание",
          isMultiLang: true,
          type: 'textarea',
        },
        {
          key: "price",
          label: "Стоимость",
          type: "field",
          textType: "number",
        },
        {
          key: "period",
          label: "Период (месяцев)",
          type: "field",
          textType: "number",
        },
        {
          key: "is_active",
          label: "Период (месяцев)",
          type: "checkbox",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_tariff",
      itemLink: "tariffs",
      setLink: "tariffs",
      columns: [
        {
          key: "title",
          title: "Название",
        },
        {
          key: "is_active",
          title: "Активность",
        },
        {
          key: "price",
          title: "Стоимость",
        },
        {
          key: "period",
          title: "Период (мес.)",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>

</style>
